import {Injectable} from '@angular/core';
import {Http} from "@angular/http";
import {Router} from "@angular/router";
import {BehaviorSubject} from 'rxjs/BehaviorSubject';

import {environment} from "../../../environments/environment";
import {LoginModel} from "../../auth/login/login.model";
import {UserModel} from "../models/user/user.model";

@Injectable()
export class AuthenticationService {

    private user: UserModel;
    private userChange = new BehaviorSubject<UserModel>(this.user);
    userChange$ = this.userChange.asObservable();

    constructor(private http: Http, private router: Router) {
        if(localStorage.getItem('user')) {
            this.setUserFromStorage();
        } else {
            this.router.navigateByUrl('auth/login');
        }
    }

    getUser() {
        return this.user;
    }

    login(model: LoginModel) {
        let self = this;
        return new Promise((resolve, reject) => {
            this.http.post(
                environment.backendUrl+'api/auth/sign-in',
                JSON.stringify(model.serialize())
            ).subscribe(
                response => {
                    if ((<any>response).errors !== undefined) {

                        return reject({status: false, object: (<any>response).errors});

                    } else {
                        let user = self.updateStorage(response);
                        return resolve({status: true, object: user});
                    }
                },
                error => {
                    return reject({status: false, object: error.json()})
                }
            );
        });
    }

    setUserFromStorage() {
        let userObject = JSON.parse(localStorage.getItem('user'));
        this.user = new UserModel(
            userObject.id, userObject.name, userObject.surname, userObject.email, null, userObject.token, userObject.avatar
        );
    }

    updateStorage(response) {
        let user = response.hasOwnProperty('token') ? response : response.json();
        localStorage.setItem('token', user.token);
        localStorage.setItem('user', JSON.stringify(user));
        this.setUserFromStorage();
        this.userChange.next(this.getUser()); 
        return user;
    }

    logout() {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        this.user = null;
        this.router.navigate(['/auth/login']);
    }
} 


// WEBPACK FOOTER //
// /code/frontend/src/app/shared/services/authentication.service.ts